<div class="checkout-page">
  <header class="checkout-header">
    <div class="kota-container checkout-header__inner">
      <a routerLink="/" class="checkout-header__logo">
        <img src="assets/img/kota_logo.png" alt="KOTA" class="checkout-header__logo-img" />
      </a>

      <ol class="checkout-steps" aria-label="Progreso de compra">
        @for (s of [1, 2, 3]; track s; let i = $index) {
          <li
            class="checkout-steps__item"
            [class.checkout-steps__item--done]="step() > s"
            [class.checkout-steps__item--active]="step() === s"
            [class.checkout-steps__item--todo]="step() < s"
          >
            <button
              type="button"
              class="checkout-steps__badge"
              [class.checkout-steps__badge--check]="step() > s"
              [class.checkout-steps__badge--muted]="step() < s"
              [disabled]="step() <= s"
              (click)="goToStep($any(s))"
              [attr.aria-current]="step() === s ? 'step' : null"
            >
              @if (step() > s) {
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3">
                  <path d="M20 6 9 17l-5-5" />
                </svg>
              } @else {
                {{ s }}
              }
            </button>
            <span
              class="checkout-steps__label"
              [class.checkout-steps__label--muted]="step() < s"
            >{{ ['Envío', 'Método', 'Pago'][i] }}</span>
          </li>
          @if (i < 2) {
            <li class="checkout-steps__line" [class.checkout-steps__line--done]="step() > s" aria-hidden="true"></li>
          }
        }
      </ol>

      <p class="checkout-header__secure">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
          <rect width="18" height="11" x="3" y="11" rx="2" ry="2" />
          <path d="M7 11V7a5 5 0 0 1 10 0v4" />
        </svg>
        Conexión segura
      </p>
    </div>
  </header>

  <main class="checkout-main">
    <div class="kota-container checkout-main__inner">

      <!-- PASO 1 — DATOS DE ENVÍO -->
      @if (step() === 1) {
        <div class="checkout-layout kota-enter-seq">
          <section class="checkout-card" aria-labelledby="ship-heading">
            <h2 id="ship-heading" class="checkout-card__title">Dirección de Envío</h2>

            @if (isLoggedIn() && addresses().length > 0 && !showNewAddressForm()) {
              <!-- Selección de dirección guardada -->
              <div class="addr-list">
                @for (addr of addresses(); track addr.id) {
                  <button
                    type="button"
                    class="addr-card"
                    [class.addr-card--selected]="selectedAddressId() === addr.id"
                    (click)="selectAddress(addr)"
                  >
                    <span class="addr-card__radio" aria-hidden="true"></span>
                    <div class="addr-card__body">
                      <span class="addr-card__name">{{ addr.full_name }}</span>
                      @if (addr.is_default) {
                        <span class="addr-card__badge">Predeterminada</span>
                      }
                      <span class="addr-card__line">{{ addr.street }}</span>
                      <span class="addr-card__line">{{ addr.city }}, {{ addr.state }} {{ addr.zip_code }}</span>
                      <span class="addr-card__line">{{ addr.phone }}</span>
                    </div>
                  </button>
                }
              </div>
              <button type="button" class="addr-new-btn" (click)="toggleNewAddressForm()">
                + Agregar nueva dirección
              </button>
              <div class="checkout-nav checkout-nav--end" style="margin-top:1.5rem">
                <button
                  type="button"
                  class="checkout-btn checkout-btn--primary"
                  [disabled]="selectedAddressId() === null"
                  (click)="nextStep()"
                >
                  Continuar
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M5 12h14M12 5l7 7-7 7" /></svg>
                </button>
              </div>

            } @else {
              <!-- Formulario nueva dirección -->
              <form class="checkout-form" [formGroup]="shippingForm" (ngSubmit)="nextStep()">
                @if (isLoggedIn() && showNewAddressForm()) {
                  <button type="button" class="addr-back-btn" (click)="showNewAddressForm.set(false); selectedAddressId.set(addresses()[0].id)">
                    ← Mis direcciones
                  </button>
                }
                <div class="checkout-form__row">
                  <div class="checkout-field">
                    <label class="checkout-field__label" for="s-first">Nombre *</label>
                    <input id="s-first" formControlName="firstName" class="checkout-field__input" [class.checkout-field__input--error]="isInvalid('firstName')" type="text" autocomplete="given-name" />
                    @if (isInvalid('firstName')) { <span class="checkout-field__error">Campo requerido</span> }
                  </div>
                  <div class="checkout-field">
                    <label class="checkout-field__label" for="s-last">Apellido *</label>
                    <input id="s-last" formControlName="lastName" class="checkout-field__input" [class.checkout-field__input--error]="isInvalid('lastName')" type="text" autocomplete="family-name" />
                    @if (isInvalid('lastName')) { <span class="checkout-field__error">Campo requerido</span> }
                  </div>
                </div>
                <div class="checkout-form__row">
                  <div class="checkout-field">
                    <label class="checkout-field__label" for="s-email">Email *</label>
                    <input id="s-email" formControlName="email" class="checkout-field__input" [class.checkout-field__input--error]="isInvalid('email')" type="email" autocomplete="email" />
                    @if (isInvalid('email')) { <span class="checkout-field__error">Email inválido</span> }
                  </div>
                  <div class="checkout-field">
                    <label class="checkout-field__label" for="s-phone">Teléfono *</label>
                    <input id="s-phone" formControlName="phone" class="checkout-field__input" [class.checkout-field__input--error]="isInvalid('phone')" type="tel" autocomplete="tel" maxlength="10" inputmode="numeric" />
                    @if (isInvalid('phone')) { <span class="checkout-field__error">10 dígitos requeridos</span> }
                  </div>
                </div>
                <div class="checkout-field">
                  <label class="checkout-field__label" for="s-addr">Calle y número *</label>
                  <input id="s-addr" formControlName="address" class="checkout-field__input" [class.checkout-field__input--error]="isInvalid('address')" type="text" autocomplete="street-address" />
                  @if (isInvalid('address')) { <span class="checkout-field__error">Campo requerido</span> }
                </div>
                <div class="checkout-form__row">
                  <div class="checkout-field">
                    <label class="checkout-field__label" for="s-city">Ciudad *</label>
                    <input id="s-city" formControlName="city" class="checkout-field__input" [class.checkout-field__input--error]="isInvalid('city')" type="text" autocomplete="address-level2" />
                    @if (isInvalid('city')) { <span class="checkout-field__error">Campo requerido</span> }
                  </div>
                  <div class="checkout-field">
                    <label class="checkout-field__label" for="s-state">Estado *</label>
                    <select id="s-state" formControlName="state" class="checkout-field__input" [class.checkout-field__input--error]="isInvalid('state')">
                      <option value="" disabled>Selecciona un estado</option>
                      <option>Aguascalientes</option>
                      <option>Baja California</option>
                      <option>Baja California Sur</option>
                      <option>Campeche</option>
                      <option>Chiapas</option>
                      <option>Chihuahua</option>
                      <option>Ciudad de México</option>
                      <option>Coahuila</option>
                      <option>Colima</option>
                      <option>Durango</option>
                      <option>Estado de México</option>
                      <option>Guanajuato</option>
                      <option>Guerrero</option>
                      <option>Hidalgo</option>
                      <option>Jalisco</option>
                      <option>Michoacán</option>
                      <option>Morelos</option>
                      <option>Nayarit</option>
                      <option>Nuevo León</option>
                      <option>Oaxaca</option>
                      <option>Puebla</option>
                      <option>Querétaro</option>
                      <option>Quintana Roo</option>
                      <option>San Luis Potosí</option>
                      <option>Sinaloa</option>
                      <option>Sonora</option>
                      <option>Tabasco</option>
                      <option>Tamaulipas</option>
                      <option>Tlaxcala</option>
                      <option>Veracruz</option>
                      <option>Yucatán</option>
                      <option>Zacatecas</option>
                    </select>
                    @if (isInvalid('state')) { <span class="checkout-field__error">Campo requerido</span> }
                  </div>
                  <div class="checkout-field checkout-field--zip">
                    <label class="checkout-field__label" for="s-zip">C.P. *</label>
                    <input id="s-zip" formControlName="zip" class="checkout-field__input" [class.checkout-field__input--error]="isInvalid('zip')" type="text" autocomplete="postal-code" maxlength="5" />
                    @if (isInvalid('zip')) { <span class="checkout-field__error">5 dígitos requeridos</span> }
                  </div>
                </div>
                <div class="checkout-nav checkout-nav--end">
                  <button type="submit" class="checkout-btn checkout-btn--primary" [disabled]="savingAddress()">
                    @if (savingAddress()) { Guardando… } @else {
                      Continuar
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M5 12h14M12 5l7 7-7 7" /></svg>
                    }
                  </button>
                </div>
              </form>
            }
          </section>

          <ng-container *ngTemplateOutlet="orderSummary"></ng-container>
        </div>
      }

      <!-- PASO 2 — MÉTODO DE ENVÍO -->
      @if (step() === 2) {
        <div class="checkout-layout kota-enter-seq">
          <section class="checkout-card" aria-labelledby="ship-method-heading">
            <h2 id="ship-method-heading" class="checkout-card__title">Método de Envío</h2>
            <div class="ship-options">
              @for (opt of shippingOptions; track opt.id) {
                <label
                  class="ship-option"
                  [class.ship-option--selected]="selectedShipping().id === opt.id"
                >
                  <input
                    type="radio"
                    name="shipping"
                    [value]="opt.id"
                    class="ship-option__radio"
                    [checked]="selectedShipping().id === opt.id"
                    (change)="selectedShipping.set(opt)"
                  />
                  <span class="ship-option__fake-radio" aria-hidden="true"></span>
                  <div class="ship-option__info">
                    <span class="ship-option__label">{{ opt.label }}</span>
                    <span class="ship-option__desc">{{ opt.description }}</span>
                  </div>
                  <span class="ship-option__price">
                    {{ opt.price === 0 ? 'Gratis' : formatMoney(opt.price) }}
                  </span>
                </label>
              }
            </div>
            <div class="checkout-nav">
              <button type="button" class="checkout-btn checkout-btn--ghost" (click)="prevStep()">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M19 12H5M12 19l-7-7 7-7" /></svg>
                Regresar
              </button>
              <button type="button" class="checkout-btn checkout-btn--primary" (click)="nextStep()">
                Continuar
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M5 12h14M12 5l7 7-7 7" /></svg>
              </button>
            </div>
          </section>

          <ng-container *ngTemplateOutlet="orderSummary"></ng-container>
        </div>
      }

      <!-- PASO 3 — PAGO -->
      @if (step() === 3) {
        <div class="checkout-layout kota-enter-seq">
          <section class="checkout-card" aria-labelledby="pay-heading">
            <h2 id="pay-heading" class="checkout-card__title">Método de Pago</h2>

            <p class="pay-sub">Elige cómo pagar en la página segura de Stripe.</p>

            <div class="pay-options-info">
              <div class="pay-option-info">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
                  <rect width="20" height="14" x="2" y="5" rx="2" />
                  <path d="M2 10h20" />
                </svg>
                <div>
                  <p class="pay-option-info__label">Tarjeta de crédito o débito</p>
                  <p class="pay-option-info__desc">Visa, Mastercard, American Express · Meses sin intereses disponibles (3 y 6 MSI)</p>
                </div>
              </div>
              <div class="pay-option-info">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
                  <path d="M18 3a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3 3 3 0 0 0 3-3 3 3 0 0 0-3-3H6a3 3 0 0 0-3 3 3 3 0 0 0 3 3 3 3 0 0 0 3-3V6a3 3 0 0 0-3-3 3 3 0 0 0-3 3 3 3 0 0 0 3 3h12a3 3 0 0 0 3-3 3 3 0 0 0-3-3z" />
                </svg>
                <div>
                  <p class="pay-option-info__label">Transferencia bancaria (SPEI)</p>
                  <p class="pay-option-info__desc">Stripe te enviará los datos bancarios por correo</p>
                </div>
              </div>
            </div>

            <div class="pay-notice">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
                <rect width="18" height="11" x="3" y="11" rx="2" ry="2" />
                <path d="M7 11V7a5 5 0 0 1 10 0v4" />
              </svg>
              <p>
                Serás redirigido a
                <a href="https://stripe.com/mx" class="pay-notice__link" target="_blank" rel="noopener noreferrer">Stripe</a>
                para elegir y completar el pago de forma segura.
              </p>
            </div>

            @if (error()) {
              <div class="checkout-error" role="alert">{{ error() }}</div>
            }

            <div class="checkout-nav">
              <button type="button" class="checkout-btn checkout-btn--ghost" (click)="prevStep()" [disabled]="loading()">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M19 12H5M12 19l-7-7 7-7" /></svg>
                Regresar
              </button>
              <button type="button" class="checkout-btn checkout-btn--primary" (click)="confirm()" [disabled]="loading()">
                @if (loading()) {
                  <span class="checkout-btn__spinner" aria-hidden="true"></span>
                  Redirigiendo...
                } @else {
                  Ir a Pagar
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M20 6 9 17l-5-5" /></svg>
                }
              </button>
            </div>
          </section>

          <ng-container *ngTemplateOutlet="orderSummary"></ng-container>
        </div>
      }

    </div>
  </main>
</div>

<!-- Resumen lateral reutilizable -->
<ng-template #orderSummary>
  <aside class="checkout-summary" aria-labelledby="order-heading">
    <h2 id="order-heading" class="checkout-summary__title">Tu Pedido</h2>

    @if (items().length === 0) {
      <p class="checkout-summary__empty">El carrito está vacío.</p>
    } @else {
      <ul class="checkout-summary__items">
        @for (line of items(); track line.id) {
          <li class="checkout-sum-line">
            <img [src]="line.image" [alt]="line.name" class="checkout-sum-line__img" width="64" height="64" loading="lazy" />
            <div class="checkout-sum-line__info">
              <span class="checkout-sum-line__name">{{ line.name }}</span>
              <span class="checkout-sum-line__qty">Cantidad: {{ line.qty }}</span>
            </div>
            <span class="checkout-sum-line__price">{{ formatMoney(line.unitPrice * line.qty) }}</span>
          </li>
        }
      </ul>
    }

    <div class="checkout-summary__divider"></div>

    <div class="checkout-summary__rows">
      <div class="checkout-summary__row">
        <span>Subtotal</span>
        <span>{{ formatMoney(subtotal()) }}</span>
      </div>
      <div class="checkout-summary__row">
        <span>Envío</span>
        <span [class.checkout-summary__free]="shippingCost() === 0">
          {{ shippingCost() === 0 ? 'Gratis' : formatMoney(shippingCost()) }}
        </span>
      </div>
    </div>

    <div class="checkout-summary__divider"></div>

    <div class="checkout-summary__total">
      <span>Total</span>
      <span>{{ formatMoney(total()) }}</span>
    </div>
  </aside>
</ng-template>
